import { observer } from 'mobx-react-lite';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AutoReplyCustomAwayMessage from '../AutoReplyComponents/AutoReplyCustomAwayMessage/AutoReplyCustomAwayMessage';
import { useRootStore } from '../../../../mobx/bridge';
import styles from './CustomAwayMessages.module.css';
import { AutoReplyTypeEnum } from '../../../../helpers/utils';
import AddAutoReplyWindow from '../AutoReplyComponents/AddAutoReplyWindow/AddAutoReplyWindow';

const tableContainerStyle = {
  root: styles.tableContainer,
};

const headerTableCellStyle = {
  root: styles.headerTableCellSeparator,
};

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const CustomAwayMessages = observer(function CustomAwayMessages() {
  const { autoReplyV2Store } = useRootStore();
  const { t } = useTranslation();

  const [addAwayMessageButton, setAddAwayMessageButton] = React.useState(null);

  const showAddCustomAwayMessageWindow = (e) => {
    setAddAwayMessageButton(e.currentTarget);
  };

  const closeAddCustomAwayMessageWindow = () => {
    if (addAwayMessageButton) {
      setAddAwayMessageButton(null);
    }
  };

  return (
    <>
      <Grid component="div" item xs={12}>
        <h2 className={styles.subTitle}>{t('CustomAwayMessages.CustomAwayMessageTitle')}</h2>
        <Tooltip
          PopperProps={{ disablePortal: true }}
          arrow
          enterDelay={1000}
          title={t('CustomAwayMessages.CustomAwayMessageTooltip')}
        >
          <div className={styles.helpIcon} />
        </Tooltip>
      </Grid>

      <TableContainer classes={tableContainerStyle}>
        <Table aria-label={t('CustomAwayMessages.CustomAwayMessageTitle')}>
          <TableHead>
            <TableRow>
              <TableCell classes={headerTableCellStyle} />
              <TableCell classes={headerTableCellStyle}>{t('CustomAwayMessages.Title')}</TableCell>
              <TableCell classes={headerTableCellStyle}>
                {t('CustomAwayMessages.Message')}
              </TableCell>
              <TableCell classes={headerTableCellStyle} />
              <TableCell classes={headerTableCellStyle} />
            </TableRow>
          </TableHead>
          <TableBody>
            {autoReplyV2Store.getCustomAwayMessageAutoReplies.map((row) => (
              <AutoReplyCustomAwayMessage key={row._id} data={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Tooltip arrow enterDelay={1000} title={t('CustomAwayMessages.AddMessage')}>
        <button
          type="button"
          className={styles.addMessageBtn}
          onClick={showAddCustomAwayMessageWindow}
        >
          {`+${t('CustomAwayMessages.AddMessage')}`}
        </button>
      </Tooltip>
      {addAwayMessageButton ? (
        <AddAutoReplyWindow
          title={t('CustomAwayMessages.CreateNewCustomMessage')}
          button={addAwayMessageButton}
          onClose={closeAddCustomAwayMessageWindow}
          arrowDirection="right-end"
          autoReplyType={AutoReplyTypeEnum.CustomAwayMessage}
        />
      ) : null}
    </>
  );
});
CustomAwayMessages.whyDidYouRender = true;
CustomAwayMessages.displayName = 'CustomAwayMessages';

export default CustomAwayMessages;
